import { KeyedValue } from "@core/models/interfaces/common";

export const capitalizeDropdownTitle = (item: KeyedValue) => {
  const title = item.title;
  return `<strong>${title.split(':')[0]}: </strong>${title.split(':').slice(1).join(':')}`
}